module.exports = __webpack_public_path__ + "static/media/ic_eye_closed copy.afc16050.svg";